import { Howler, Howl } from 'howler';
import Voice from './Voice';
import gsap from 'gsap';
import MusicAnalyzer from './MusicAnalyzer';

export default class Audio {
    static instance = null;

    sounds = new Map(); // { id: { howl, src, opts } }
    currentId = null;   // id del sonido en reproducción
    autoId = 0;         // contador interno para asignar ids únicos

    subtitleRaf = null;
    lastSubtitle = null;

    analyzer = null;
    audioContext = null;
    // audioContext = new AudioContext();

    initialized = false;

    _call = () => this.loop();

    constructor() {
        if (Audio.instance) return Audio.instance;
        Audio.instance = this;
    }

    static getInstance() {
        if (!Audio.instance) {
            Audio.instance = new Audio();
        }
        return Audio.instance;
    }

    initAnalyzer() {
        this.audioContext = Howler.ctx;
        this.analyzer = new MusicAnalyzer(this.audioContext);

        Howler.masterGain.connect(this.analyzer.instance);
        this.analyzer.instance.connect(this.audioContext.destination);

        this.initialized = true;
    }

    add(__src, __opts = {}) {
        const id = ++this.autoId;
        const def = {
            volume: 1,
            preload: true,
            html5: false,
            onload: () => {
                // console.log("🎧 Sonido precargado");
            },
            onloaderror: (id, err) => {
                console.error("❌ Error al cargar el sonido", err);
            },
            onend: () => {
                this.currentId = null;
                this.stopSubtitles();
                Voice.getInstance().hide();
            }
        };
        const opts = { ...def, ...__opts };
        const howl = new Howl({
            src: Array.isArray(__src) ? __src : [__src],
            ...opts
        });

        this.sounds.set(id, { howl, __src, opts });

        if (!this.initialized) this.initAnalyzer();

        return id;

    }

    /**
     * Reproduce un sonido por su id
     * Si otro estaba sonando, lo para
     */
    play(id) {
        if (!this.sounds.has(id)) {
            console.warn(`⚠️ El sonido con id ${id} no existe`);
            return;
        }

        // Detiene el sonido actual si es distinto
        if (this.currentId && this.currentId !== id) this.stop(this.currentId);

        const { howl, opts } = this.sounds.get(id);

        if (!howl.playing()) {
            this.currentId = id;

            if (opts.subtitles) {
                Voice.getInstance().show();

                if (this.audioContext.state === 'suspended') {
                    this.audioContext.resume();
                }

                gsap.ticker.add(this._call);
            }

            howl.play();
        }
    }

    /**
     * Detiene un sonido por id
     */
    stop(id) {
        id = id || this.currentId;
        if (!this.sounds.has(id)) return;
        const { howl } = this.sounds.get(id);
        howl.stop();
        if (this.currentId === id) {
            this.currentId = null;
            this.stopSubtitles();
        }
    }

    stopSubtitles() {
        if (this.subtitleRaf) {
            this.subtitleRaf = null;
            this.lastSubtitle = null;
            gsap.ticker.remove(this._call);
        }
    }

    loop() {
        if (!this.currentId) return;

        const { howl, opts: { subtitles } } = this.sounds.get(this.currentId);

        if (!howl.playing() || !subtitles) return;

        // 🔊 ANALISIS AUDIO
        // const { bass, mid, treble } = this.analyzer.analyzeMusic();
        // console.log('ANALYSIS:', { bass, mid, treble });

        const currentTime = howl.seek() * 1000; // en ms
        for (const sub of subtitles) {
            const start = sub.start ? parseInt(sub.start, 10) : 0;
            const end = parseInt(sub.end, 10);

            if (currentTime >= start && currentTime < end) {
                if (this.lastSubtitle !== sub) {
                    // console.log("📝 Subtitle:", sub.text);
                    Voice.getInstance().talk(sub.text);
                    this.lastSubtitle = sub;
                }
                break;
            }
        }
    }

    dispose() {
        for (const [id, { howl }] of this.sounds.entries()) {
            howl.unload();
        }
        this.sounds.clear();
        this.currentId = null;
        this.stopSubtitles();
        Voice.getInstance().hide();
    }
}
